import { shopRoleCan } from '@guildite/domain/shops';
import { useEffect, useMemo, useState } from 'react';

import { useCurrentUser, useData } from '../../data/DataContext.tsx';
import { useMyShops } from '../shops/MyShopsContext.tsx';

// New paid orders waiting in every shop you handle orders for (the Orders
// tab's badge and its "Shop orders · N new" label).
export function useNewShopOrders(): number {
  const { orders } = useData();
  const user = useCurrentUser();
  const { shops } = useMyShops();
  const ids = useMemo(() => (user ? shops.filter(shop => shopRoleCan(shop.role, 'manage_orders')).map(shop => shop.shopId).sort().join(',') : ''), [user, shops]);
  const [counts, setCounts] = useState<{ key: string; byShop: Record<string, number> }>({ key: '', byShop: {} });
  useEffect(() => {
    if (!ids) return;
    const stops = ids.split(',').map(shopId => orders.watchShop(
      shopId,
      list => setCounts(current => ({ key: ids, byShop: { ...(current.key === ids ? current.byShop : {}), [shopId]: list.filter(order => order.stage === 'new').length } })),
      () => undefined,
    ));
    return () => stops.forEach(stop => stop());
  }, [orders, ids]);
  return counts.key === ids && ids ? Object.values(counts.byShop).reduce((sum, count) => sum + count, 0) : 0;
}
